import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderRadius as radius,
  borderStyle,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { KG_NODE_PILL_MAX_WIDTH_PX } from "../../kg/kgNodeDimensions";
import { kgCategorySelectionShadow } from "../../kg/kgLineageTokens";
import {
  kgNodeEllipsisTextStyles,
  kgNodeTextContainerStyles,
} from "../../kg/kgNodeText.styles";
import type { KgNodeVisualState } from "../../kg/kgNodeShared.types";

export const Card = styled.div<{
  $visualState: KgNodeVisualState;
  $isSelected: boolean;
}>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing[3]};
  max-width: ${KG_NODE_PILL_MAX_WIDTH_PX}px;
  overflow: hidden;
  padding: ${spacing[3]} ${spacing[5]};
  border-radius: 14px;
  border: ${borderWidth[1]} ${({ $visualState }) =>
    $visualState === "draft" ? borderStyle.dashed : borderStyle.solid}
    ${rawColors.accent.artifactBlue};
  background: ${rawColors.structural.white};
  box-shadow: ${({ $isSelected }) =>
    kgCategorySelectionShadow("output", $isSelected)};
  outline: none;
  transition: box-shadow 0.25s ease;
  cursor: pointer;
`;

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${radius.lg};
  background: ${rawColors.accent.artifactBlueBg};
  color: ${rawColors.accent.artifactBlue};
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  flex: 1;
  ${kgNodeTextContainerStyles}
`;

export const Label = styled.span`
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
  ${kgNodeEllipsisTextStyles}
`;

export const Name = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  ${kgNodeEllipsisTextStyles}
`;
